import { makeStyles } from '@material-ui/styles';
import theme from '../../../theme';
import { useEffect, useState } from 'react';
import useSessionStore from '@services/stores/SessionStore';
import useApplicationStore from '@services/stores/ApplicationStore';
import { newportRounding } from '@services/Utils';

const useStyles = makeStyles({
    labels: {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 6,
        padding: '6px',
        [theme.breakpoints.up('md')]: {
            top: 0,
        },
        '&:has(.pre-access) .marketing': {
            '@media (max-width: 450px)': {
                display: 'none',
            },
        },
        '&.large': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            top: 10,
            right: 10,
            left: 10,
            gap: 12,
            [theme.breakpoints.up('md')]: {
                alignItems: 'flex-end',
                left: 'initial',
            },
        },
        '& .marketing-OUTDOOR10': {
            background: 'rgb(94, 175, 210)',
            color: '#ffffff',
        },
        '& .pre-access': {
            // background: '#06213d',
            background: '#000',
            // color: '#fbd7a2',
            color: '#fff',
            textTransform: 'uppercase',
            '& b': {
                display: 'none',
            },
        },
        '.coupon-preaccess & .pre-access b, .coupon-sms-vip & .pre-access b, .coupon-priority & b, .coupon-friend-vip & b': {
            display: 'inline !important',
        }
    },
    marketingLabel: {
        background: '#000',
        color: '#fff',
        padding: '4px 10px',
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px 10px 1px 10px',
        whiteSpace: 'nowrap',
        fontSize: 13,
        fontWeight: 400,
        lineHeight: '22px',
        background: '#ffffff',
        color: '#000000',
        pointerEvents: 'none',
        width: 'max-content',

        // ✨ Fade-in magic
        opacity: 0,
        transform: 'translateY(-4px)',
        transition: 'opacity 0.4s ease-out, transform 0.4s ease-out',

        '&.fade-in': {
            opacity: 1,
            transform: 'translateY(0)',
        },

        '&.dark': {},
        '.large &': {
            fontSize: 15,
            padding: '8px 20px',
        },
    },
    left: {
        gridColumn: 1,
        justifySelf: 'self-start',
    },
    right: {
        gridColumn: 2,
        justifySelf: 'self-end',
    },
});

export default function ProductLabels(
    {
        available,
        streamIds = [],
        propertyIds = [],
        prices,
        large = false,
    },
) {
    const appMethods = useApplicationStore((state) => state.methods);
    const sessionActions = useSessionStore((state) => state.methods);
    const classes = useStyles();
    const [ isClient, setIsClient ] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        // Set to true only when the component has mounted (client-side)
        setIsClient(true);
        setTimeout(() => setFadeIn(true), 50);
    }, []);

    if (!isClient) return null; // Don't render on the server

    const hasLightButtons = propertyIds?.includes('12dba8fc3431593d890d5802b96bb751') ? 'light' : false;
    const marketingLabels = appMethods.getMarketingLabels(propertyIds);
    const size = large ? 'large' : 'small';

    function renderLabel(
        label,
        labelClass,
        position = classes.left
    ) {
        const labelStyle = [classes.labelContainer, labelClass, size, position];

        if (hasLightButtons) {
            labelStyle.push(hasLightButtons);
        }

        if (fadeIn) labelStyle.push('fade-in'); // 👈 add fade-in class after mount

        return <span
            key={`disco-bubble-${label}-${labelClass}`}
            className={labelStyle.join(' ')}
            dangerouslySetInnerHTML={{ __html: label }}
        ></span>;
    }

    function hasAllowedProductStreams() {
        const allowedStreamIds = [
            '0199b8e1a0f37470a19f55de691646ec', // 70%
            '0199b8e87a3b72a1b977468efaded620', // 50%
            '01931babf0667a4c8da1d8e9fde47ab6', // 20%
        ].join(',');
        return streamIds.filter((id) => allowedStreamIds.includes(id)).length > 0;
    }

    function renderStreamIds(productStreamIds) {
        if (!Array.isArray(productStreamIds) || !(productStreamIds.length > 0)) {
            return null;
        }

        if (!sessionActions.isSalesChannelNordic()) {
            return null;
        }

        if (prices.discount) {
            return null;
        }

        if (!available) {
            return null;
        }

        if ((new Date()) > new Date('Nov 9, 2025 23:59:59')) {
            return null;
        }

        if (hasAllowedProductStreams()) {
            const percentage = Object.entries({
                '0199b8e1a0f37470a19f55de691646ec': 70,
                '0199b8e87a3b72a1b977468efaded620': 50,
                '01931babf0667a4c8da1d8e9fde47ab6': 20,
            }).find(([key, value]) => productStreamIds.includes(key))[1];
            return renderLabel(`Pre-Access&nbsp;<b>${percentage}%</b>`, 'pre-access', classes.right);
        }

        return null;
    }

    let labels = [];

    if (marketingLabels?.length > 0) {
        marketingLabels.map((label) => {
            labels.push(renderLabel(label, `marketing marketing-${label}`));
        });
    }

    if (prices?.discount && available) {
        labels.push(renderLabel(`${newportRounding(prices.discount.percentage)}%`, 'discount', classes.right));
    }

    if (streamIds?.length) {
        labels.push(renderStreamIds(streamIds));
    }

    if (labels?.length <= 0) {
        return null;
    }


    return (<div className={[ classes.labels, size ].join(' ')}>
        {labels}
    </div>);
}
